import { render, staticRenderFns } from "./GroupMobileSlipList.vue?vue&type=template&id=30988719"
import script from "./GroupMobileSlipList.vue?vue&type=script&lang=js"
export * from "./GroupMobileSlipList.vue?vue&type=script&lang=js"
import style0 from "./GroupMobileSlipList.vue?vue&type=style&index=0&id=30988719&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports